export default {
	SET_AXIOS_TOKEN (state, payload) {
		state.axiosToken = payload
	},
	SET_GUEST_ID (state, payload) {
		state.guestId = payload
	},
	SET_READY (state, payload) {
		state.ready = payload
	},
	SET_AVAILABLE_LANGUAGES (state, payload) {
		state.availableLanguages = payload
	},
	SET_LOADING (state, payload) {
		state.loading = payload
	},
	SET_USER (state, payload) {
		state.user = payload
	},
	SET_TEAMS (state, payload) {
		state.userTeams = payload
	},
	SET_TEAM (state, payload) {
		state.userTeam = payload
	},
	SET_TEAM_PLAN (state, payload) {
		state.userTeam.plan = payload
	},
	SET_TRANSLATIONS (state, payload) {
		state.translations = payload
	},
	SET_AUTH (state, payload) {
		state.auth = payload
	},
	SET_NAVIGATION_STATE (state, payload) {
		state.activeNavigation = payload
	},
	SET_THEME (state, payload) {
		state.theme = payload
	},
	SET_LEAVE_CONFIRMATION (state, payload) {
		state.leaveConfirmation = payload
	},
	SET_SHOW_SWITCH_TEAM (state, payload) {
		state.showSwitchTeam = payload
	},
	SET_SHOW_EXPIRATION_DIALOG (state, payload) {
		state.showExpirationDialog = payload
	},
	SET_SHOW_PLAN_LIMIT_DIALOG (state, payload) {
		state.showPlanLimitDialog = payload
	}
}
